import { parseUrl, stringify } from 'query-string'

/**
 * This function is required because of varnish cache can replace queryID with the worng one.
 * @param {NodeListOf<Element>} variantLinks
 * @param {string} currentPageUrl
 */
export const setQueryIDForVariants = (variantLinks, currentPageUrl) => {
  const { query } = parseUrl(currentPageUrl)

  const shouldSetQueryID = Boolean(query?.queryID) && Boolean(currentPageUrl)
  if (!shouldSetQueryID) {
    return
  }

  const { queryID } = query
  variantLinks.forEach(variant => {
    const {
      url: variantUrl,
      query: { queryID: variantQueryID, ...rest }
    } = parseUrl(variant.href)
    const newVariantQueryParams = stringify({ ...rest, queryID })
    // eslint-disable-next-line no-param-reassign
    variant.href = `${variantUrl}?${newVariantQueryParams}`
  })
}

export default () => {
  const variantLinks = document.querySelectorAll(
    '[data-clientside-hook~="productVariant__link"]'
  )
  const currentPageUrl = window?.location?.href
  setQueryIDForVariants(variantLinks, currentPageUrl)
}
